import {
  RecurrenceScheduleDate,
  RecurrenceScheduleDateStatus,
  RecurringDocumentStatus,
  RecurringInvoice
} from "@wingspanhq/wingspan-api-sdk";
import { getLocalStartDayByUTC, getStartOfDay } from "../../utils/dates";

const TERMINAL_SERIES_STATUSES: Array<RecurringDocumentStatus | undefined> = [
  RecurringDocumentStatus.CANCELLED
];

export const selectorOccurrenceStatusText = (request: {
  scheduleDate: RecurrenceScheduleDate;
  seriesStatus?: RecurringDocumentStatus;
  override?: RecurringInvoice;
}): string => {
  const { scheduleDate, seriesStatus, override } = request;

  if (scheduleDate.status === RecurrenceScheduleDateStatus.COMPLETED) {
    return "Sent";
  }

  if (TERMINAL_SERIES_STATUSES.includes(seriesStatus)) {
    return "Cancelled";
  }

  if (scheduleDate.status === RecurrenceScheduleDateStatus.SKIPPED) {
    return getLocalStartDayByUTC(scheduleDate.date) >= getStartOfDay()
      ? "Skipping"
      : "Skipped";
  }

  if (scheduleDate.status === RecurrenceScheduleDateStatus.MODIFIED) {
    const overrideScheduleDate = override?.schedule?.scheduleDates?.[0];

    return overrideScheduleDate
      ? selectorOccurrenceStatusText({
          scheduleDate: overrideScheduleDate,
          seriesStatus: override?.status
        })
      : "–";
  }

  return "Scheduled";
};
